export default __webpack_public_path__ + "518936a19817abc769ff8702c3198618.svg";